import * as React from 'react';

import { Messages } from 'src/ui/components/Messages';
import { Notifications } from 'src/ui/components/Notifications';
import { CreateApiTokenDialog } from 'src/ui/containers/dialogs/CreateApiTokenDialog';
import { CreateVoiceboxAppDialog } from 'src/ui/containers/dialogs/CreateVoiceboxAppDialog';
import { UpdateVoiceboxAppDialog } from 'src/ui/containers/dialogs/UpdateVoiceboxAppDialog';
import { AddEndpointDialog } from 'src/ui/containers/endpoints/dialogs/AddEndpointDialog';
import { AddSsoEndpointDialog } from 'src/ui/containers/endpoints/dialogs/AddSsoEndpointDialog';
import { DeleteEndpointDialog } from 'src/ui/containers/endpoints/dialogs/DeleteEndpointDialog';
import { EditEndpointDialog } from 'src/ui/containers/endpoints/dialogs/EditEndpointDialog';
import { SignInDialog } from 'src/ui/containers/endpoints/dialogs/SignInDialog';
import { VoiceboxResponseReportDialog } from 'src/ui/containers/endpoints/dialogs/VoiceboxResponseReportDialog';
import { LaunchpadAppHooks } from 'src/ui/containers/launchpad/LaunchpadAppHooks';
import { LaunchpadNavbarWrapper } from 'src/ui/containers/launchpad/LaunchpadNavbarWrapper';
import { VoiceboxContextWrapper } from 'src/ui/containers/voicebox/VoiceboxContextWrapper';
import { getFriendlyName } from 'src/ui/utils/window';

export const LaunchpadApp: React.VFC = () => {
  React.useEffect(() => {
    document.title = getFriendlyName();
  }, []);

  return (
    <>
      <main>
        <VoiceboxContextWrapper>
          <LaunchpadNavbarWrapper />
        </VoiceboxContextWrapper>
      </main>
      <LaunchpadAppHooks />
      <Notifications />
      <Messages />
      <AddEndpointDialog isLaunchpad />
      <AddSsoEndpointDialog />
      <SignInDialog />
      <EditEndpointDialog isLaunchpad />
      <DeleteEndpointDialog />
      <CreateApiTokenDialog />
      <CreateVoiceboxAppDialog />
      <UpdateVoiceboxAppDialog />
      <VoiceboxResponseReportDialog />
    </>
  );
};
